import React, { useState, useEffect, useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Header from "../component/include/Header";
import "react-toastify/dist/ReactToastify.css";
import { BASE_PATH } from "../constants/Global";
import DataService from "../services/tutorial.service";
import { logUser } from "../actions/index";
import { useSelector, useDispatch } from "react-redux";
import 'react-phone-number-input/style.css'
import PhoneInput, { formatPhoneNumber, formatPhoneNumberIntl } from 'react-phone-number-input'
// import { formatPhoneNumber } from 'react-phone-number-input'

import { parsePhoneNumberFromString } from 'libphonenumber-js';

import {
  loadCaptchaEnginge,
  LoadCanvasTemplate,
  LoadCanvasTemplateNoReload,
  validateCaptcha,
} from "react-simple-captcha";

import OtpVerification from "./OtpVerification";

function Login() {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const dispatch = useDispatch();
  const loginuser = useSelector((state) => state.setUserlog);
  const isjoin = useSelector((state) => state.isjoin);
  const [cid, setCid] = useState(loginuser["cid"]);
  const [token, settoken] = useState(loginuser["token"]);
  const [mobvalue, setmobValue] = useState("");
  const [otpTo, setOtpTo] = useState("");
  const [isDisabled, setDisabled] = useState(false);
  const history = useHistory({ forceRefresh: true });
  const [countrynum, setcountrynum] = useState('+91')
  const [showOtpVerification, setShowOtpVerification] = useState(false);

  const phoneInputRef = useRef(null);
  const handleCountrychange = () => {
    const phoneInput = document.querySelector('.PhoneInputInput');
    const phoneValue = phoneInput ? phoneInput.value : '';
    setcountrynum(phoneValue); // Logs the value of the input field
  };
  const currentDomain = window.location.hostname;

  const hideLayoutDomains = [
    "auction.inboxwoods.com",
    "webstreaming.in",
  ];

  const hideLayout = hideLayoutDomains.includes(currentDomain);
  // const isTesting = true;
  // const hideLayout = isTesting
  //   ? true
  //   : currentDomain === "auction.inboxwoods.com";


  const onSubmit = (values) => {
    let user_captcha = document.getElementById("user_captcha_input").value;

    if (validateCaptcha(user_captcha) == false) {
      toast.error("Captcha Does Not Match", {
        theme: "colored",
        position: "bottom-center",
      });
      document.getElementById("user_captcha_input").value = "";
      return false;
    }

    setDisabled(true);


    const HEADER = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "Cache-Control": "no-cache",
        "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
      },
    };

    // var mobileformat = formatPhoneNumberIntl(mobvalue)
    // //console.log(mobvalue)
    // //console.log(mobileformat)
    // let parts = mobileformat.split(' ');

    // // Extract country code and phone number
    // let countryCode = parts[0];
    // let phoneNumber = parts.slice(1).join('')
    // //console.log(countryCode)
    // //console.log(phoneNumber)
    let phoneNumber = mobvalue

    if (phoneNumber == "") {
      toast.error("Mobile Number is required !!", {
        theme: "colored",
        position: "bottom-center",
      });
      setDisabled(false);

      return 0
    }
    else if (phoneNumber.length < 7) {
      toast.error("At least 8 digit number !!", {
        theme: "colored",
        position: "bottom-center",
      });
      setDisabled(false);

      return 0
    }
    else if (phoneNumber.length > 12) {
      toast.error("Max limit is 13 digit number !!", {
        theme: "colored",
        position: "bottom-center",
      });
      setDisabled(false);

      return 0
    }
    const id = toast.loading("Please wait...");
    let toastContainerId = toast.update(id, {
      render: "please wait...",
      theme: "dark",
      position: "bottom-center",
    });
    values['mobno'] = phoneNumber;
    // values['mobno']=parseInt(String(phoneNumber).replace(/^0+/, ''))
    values['ccode'] = countrynum
    //console.log('login values')
    //console.log(values)
    DataService.loginUser(values, HEADER)
      .then((res) => {
        let response = res.data;
        //console.log(response)
        toast.dismiss(toastContainerId);

        if (response.success == true && response.data.token) {
          //console.log('response');
          //console.log(response);
          var emptyArray = JSON.stringify(new Array(response.data));
          // //console.log(emptyArray)
          localStorage.setItem("user", emptyArray);
          dispatch(logUser(response.data));

          toast.success(response.msg, {
            theme: "dark",
            position: "bottom-center",
          });
          //console.log('isjoin')
          if (isjoin !== "") {
            history.push(BASE_PATH + "join-auction-code");

          }
          else {
            history.push(BASE_PATH + "dashboard");
          }
        }
         else if(response.success == true){
          //console.log('response.data.otpTo')
          // Show OTP verification
          //console.log('response.data.otpTo')
          //console.log(response.data)
          setOtpTo(response.data.otpTO);
          setShowOtpVerification(true);
        }
        else {
          toast.error(response.msg || "Invalid credentials", {
            theme: "colored",
            position: "bottom-center",
          });
        }

        setDisabled(false);
      })
      .catch(() => {
        // //console.log("Not valid");
        toast.dismiss(toastContainerId);
        toast.error("Not valid Server Error", {
          theme: "colored",
          position: "bottom-center",
        });
        setDisabled(false);
      });
  };

  const handleVerificationSuccess = () => {
    // Handle successful OTP verification
    toast.success("Login successful!", {
      theme: "dark",
      position: "bottom-center",
    });
    if (isjoin !== "") {
      history.push(BASE_PATH + "join-auction-code");
    } else {
      history.push(BASE_PATH + "dashboard");
    }
  };

  const handleBackFromOTP = () => {
    // First hide OTP verification
    setShowOtpVerification(false);
    
    // Wait for DOM to update before reloading captcha
    setTimeout(() => {
      loadCaptchaEnginge(6, "white", "black");
      if (document.getElementById("user_captcha_input")) {
        document.getElementById("user_captcha_input").value = "";
      }
    }, 100);
  };

  useEffect(() => {
    loadCaptchaEnginge(6, "white", "black");
    window.scrollTo(0, 0);
    // //console.log(window.__initial_headers__)
    const queryParameters = new URLSearchParams(window.location.search)
    // front login from map
    const aval = queryParameters.get("mob")
    const bval = queryParameters.get("key")
    const cidval = queryParameters.get("cid")
    const cname = queryParameters.get("cname")
    // front login from other
    // const
    const uid = queryParameters.get("uid")
    const mkey = queryParameters.get("mkey")

    /////////////////////////
    const aidval = queryParameters.get("aid")
    const cval = queryParameters.get("acode")
    const bypassval = queryParameters.get("direct")
    const pg = queryParameters.get("p")
    // //console.log("parametersssssssssss")
    if (pg !== null) {
      if (pg == 'login') {
        history.push(BASE_PATH);

      }
      else if (pg == 'registration') {
        history.push(BASE_PATH + "user-registration");

      }
      else if (pg == 'dashboard') {
        history.push(BASE_PATH + "dashboard");
      }
      else if (pg == 'profile') {
        history.push(BASE_PATH + "my-profile");

      }
      else if (pg == 'newauction') {
        // //console.log("new auc hitt")
        history.push(BASE_PATH + "new-auction");

      }
      else if (pg == 'joinauction') {
        history.push(BASE_PATH + "join-auction");

      }
      else if (pg == 'myauction') {
        history.push(BASE_PATH + "my-auction");

      }
      else if (pg == 'auctionpanel') {
        document.getElementById('acp1').value = cid;
        document.getElementById('acp2').value = 0;
        document.getElementById('acp3').value = token;
        document.getElementById('acpform').submit();

      }

    }
    if (aval !== null && mkey !== null && uid !== null) {
      const HEADER = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Cache-Control": "no-cache",
          "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
        },
      };
      // //console.log(uid)
      // //console.log(aval)
      // //console.log(mkey)
      DataService.keyloginUser({ 'cid': uid, 'mobno': aval, 'mkey': mkey }, HEADER)
        .then((res) => {
          console.log("key login res.data")
          console.log(res)
          let response = res.data;

          if (response.success == true) {
            var emptyArray = JSON.stringify(new Array(response.data));
            localStorage.setItem("user", emptyArray);
            dispatch(logUser(response.data));

            toast.success(response.msg, {
              theme: "dark",
              position: "bottom-center",
            });

            history.push(BASE_PATH + "my-auction");
          } else {
            toast.error(response.msg, {
              theme: "colored",
              position: "bottom-center",
            });
          }

        })
    }
    if (aval !== null && bval !== null && cidval != null && cname != null) {
      if (aidval !== null) {
        localStorage.setItem('auction_id', aidval)
        localStorage.setItem('admin_id', cidval)
        localStorage.setItem('admin_name', cname)
        localStorage.setItem('isadel', aidval)
      }
      // //console.log('cname and cid')
      // //console.log()

      const HEADER = {
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          "Cache-Control": "no-cache",
          "Postman-Token": "42e6c291-9a09-c29f-f28f-11872e2490a5",
        },
      };
      const formData = new FormData();
      formData.append('mobno', aval);
      formData.append('pass', bval);
      formData.append('cid', cidval);
      DataService.loginUser(formData, HEADER)
        .then((res) => {
          //console.log("res.data from here")
          //console.log(res.data)
          let response = res.data;

          if (response.success == true) {
            var emptyArray = JSON.stringify(new Array(response.data));
            localStorage.setItem("user", emptyArray);
            dispatch(logUser(response.data));
            // //console.log('login succesfull')
            // //console.log(response.data)

            toast.success(response.msg, {
              theme: "dark",
              position: "bottom-center",
            });

            history.push(BASE_PATH + "my-auction");
          } else {
            toast.error(response.msg, {
              theme: "colored",
              position: "bottom-center",
            });
          }

        })


    }
    else if (loginuser != "" && pg == null) {
      // //console.log("form here")
      history.push(BASE_PATH + "dashboard");
    }
    // //console.log(logUser['cid'])
    if (cval !== null) {
      localStorage.setItem('acode', cval)

      if (localStorage.getItem('user')) {
        if (bypassval !== null) {
          // //console.log("playing safe")
          history.push(BASE_PATH + "join-auction-code3");
        } else {

          history.push(BASE_PATH + "join-auction-code");
        }

      }
      else {
        if (bypassval !== null) {
          // //console.log("playing safe")
          history.push(BASE_PATH + "join-auction-code3");
        }
        else {

          // //console.log("playing safe")
          history.push(BASE_PATH + "join-auction-code2");
        }

      }


    }



  }, []);
  const formatPhone = (value) => {
    // Allow leading zeros
    if (value && value.startsWith('0')) {
      return value;
    }
    return value;
  };

  // useEffect(() => {

  //   //console.log('mobvalue')
  //   //console.log(mobvalue)

  // }, [mobvalue])

  return (
    <>
      {/* <Header /> */}
      <div className="login-area default-padding">
        <div className="container">
          <div className="row">
            <form id="acpform" method='get' action="https://superplayerauction.com/manage/?frnt=1" target="_blank">
              <input type="hidden" id="acp1" name="cid" />
              <input type="hidden" id="acp2" name="aid" />
              <input type="hidden" id="acp3" name="fkey" />
              {/* <input type="hidden" name="loginbyadmin" value="1" /> */}

            </form>
            <div className="col-md-6 col-md-offset-3">
              {showOtpVerification ? (
                <OtpVerification
                  otpTo={otpTo}
                  phoneNumber={mobvalue}
                  onVerificationSuccess={handleVerificationSuccess}
                  onBack={handleBackFromOTP}
                />
              ) : (
                <form
                  onSubmit={handleSubmit(onSubmit)}
                  action=""
                  autoComplete="off"
                  id="login-form"
                  className="white-popup-block regfrm"
                  encType="multipart/form-data"
                >
                  <div className="col-md-12">
                    <h4>login to your registered account!</h4>
                    <div className="col-md-12">
                      <div className="row">
                        <div className="form-group mymar phonediv">
                          <PhoneInput
                            international
                            // initialValueFormat="international"
                            withCountryCallingCode={false}

                            defaultCountry="IN"
                            countryCallingCodeEditable={false}
                            // value={mobvalue}
                            onChange={
                              (v)=>{handleCountrychange()}}
                            minLength={8}
                            // limitMaxLength={13}
                            // format={formatPhone}
                           
                          />
                          <span className="text-gray-500">{countrynum}</span>
                          <input
                            onChange={(e) => setmobValue(e.target.value)}
                            value={mobvalue}
                            type="text"
                            placeholder="Enter mobile number"
                            className="ml-2"
                            style={{ width: '100%' }}
                          />
                          {/* <input onChange={(e)=>setmobValue(e.target.value)} value={mobvalue} type="text"  name="" id="" /> */}

                          {/* <select name="" id="">
                            <option value=""></option>
                          </select> */}
                          {errors.mobno && (
                            <p className="text-error">{errors.mobno.message}</p>
                          )}
                          {/* <input
                            // maxLength={10}
                            minLength={9}
                            className="form-control"
                            placeholder="Mobile No"
                            type="number"
                            // onInput={(e) => {
                            //   e.target.value = Math.max(
                            //     0,
                            //     parseInt(e.target.value)
                            //   )
                            //     .toString()
                            //     .slice(0, 10);
                            // }}
                            {...register("mobno", {
                              required: true,
                              // maxLength: 10,
                              required: "required field.",
                              // maxLength: {
                              //   value: 10,
                              //   message: "at-least 10 characters.",
                              // },
                              minLength: {
                                value: 9,
                                message: "at-least 9 characters.",
                              },
                            })}
                          />
                          {errors.mobno && (
                            <p className="text-error">{errors.mobno.message}</p>
                          )} */}
                        </div>
                      </div>
                    </div>

                    <div className="col-md-12">
                      <div className="row">
                        <div className="form-group mymar">
                          <input
                            {...register("pass", {
                              required: true,
                              required: "required field.",
                            })}
                            className="form-control"
                            placeholder="Password"
                            type="password"
                          />
                          {errors.pass && (
                            <p className="text-error">{errors.pass.message}</p>
                          )}
                        </div>
                      </div>
                    </div><p className="forgotline"><span style={{ cursor: 'pointer' }} onClick={() => { history.push('forgotPassword') }}>Forgot password ?</span></p>
                    <div className="row">
                      <div
                        className="col-md-4 captcha"
                        style={{ textAlign: "center" }}
                      >
                        <LoadCanvasTemplate
                          reloadText="Reload  Captcha"
                          reloadColor="#002147"
                          className="cpchafont"

                        />
                      </div>

                      <div className="col-md-8 cpcha">
                        <div>
                          <input
                            placeholder=" Enter Captcha Value"
                            {...register("user_captcha_input", {
                              required: true,
                              required: "required field.",
                            })}
                            id="user_captcha_input"
                            type="text"
                            style={{ width: "100%" }}
                          ></input>
                        </div>
                        {errors.user_captcha_input && (
                          <p className="text-error">
                            {errors.user_captcha_input.message}
                          </p>
                        )}
                      </div>
                    </div>

                    <div className="col-md-12" style={{ marginTop: 15 }}>
                      <div className="row">
                        <div className="col-md-4 padding-l regsubmbtn">
                          <button disabled={isDisabled} type="submit">
                            Login
                          </button>
                        </div>

                        <div className="col-md-8 padding-r align-right regbdiv">
                          <p className="link-bottom regb">
                            {" "}
                            Not a member yet?{" "}
                            {/* Not a member yet?{" "} */}
                            <Link className="relbl" to="user-registration">Register now</Link>


                          </p>

                        </div>
                      </div>
                    </div>
                    <div className="col-md-12 trouble-msg">
                      <div className="row">
                        {!hideLayout &&(<div className="form-group mymar">
                          <i>  Any Trouble in login ? Contact : <span> 8386011123</span></i>
                        </div>)}
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default Login;
